var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cursor"},[_c('div',{ref:"pointer",staticClass:"cursor__inner cursor__inner--pointer",style:(_vm.styles.pointer)}),_c('div',{ref:"circle",staticClass:"cursor__inner cursor__inner--circle",style:(_vm.styles.circle)})])}
var staticRenderFns = []

export { render, staticRenderFns }